/**
 * The scenarios the room can view, as tabs (#1062). Pure.
 *
 * One course per scenario, in the order the scenarios are shown: by level of
 * optimism when the source has levels (the experts' set), else in the source's own
 * order. Every course has a tab once it exists, whatever its status, so a running or
 * failed one says so where it would be.
 */

/**
 * @param {object[]} timelines  the state's courses (frame_kind 'world'), already in order
 * @returns {Array<{ id: string, worldId: string, level: number|null, title: string, timeline: object }>}
 */
export function worldTabs(timelines = []) {
  return timelines
    .filter((tl) => tl.frameKind === 'world' && tl.world)
    .map((timeline) => ({
      id: timeline.id,
      worldId: timeline.worldId,
      level: timeline.world.level ?? null,
      title: timeline.world.title || timeline.title || '',
      timeline,
    }));
}

/** The tab shown by default: the first scenario. */
export const defaultTab = (tabs) => tabs[0] || null;

/** A tab's short name: "2 · Niukka arki" with a level, the title alone without. */
export const tabLabel = (tab, max = 28) => {
  const title = tab.title.length > max ? `${tab.title.slice(0, max - 1)}…` : tab.title;
  return tab.level != null ? `${tab.level} · ${title}` : title;
};
